import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/ui/PageHeader";
import CustomInput from "../../components/ui/CustomInput";
import axios from "../../api/axiosClient";
import { useLoading } from "../../components/LoadingContext";
import { errorToast, handleError } from "../../services/serviceBase";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import CustomTable from "../../components/ui/CustomTable";
import { useRef } from "react";
import CustomGridHeaderCell from "../../components/ui/CustomGridHeaderCell";
import CustomTablePagingInfo from "../../components/ui/CustomTablePagingInfo";
import Input from "@mui/material/Input";

const FromInvoice = () => {
  const intl = useIntl();

  const [types, setTypes] = useState([{ text: "Retail", value: "R" }]);
  const [type, setType] = useState({
    text: "",
    value: "",
    isTriangulation: false,
    salePriceType: "",
  });

  const [warehouseDestinations, setWarehouseDestinations] = useState([]);
  const [warehouseDestination, setWarehouseDestination] = useState({
    text: "",
    value: "",
  });

  const [reconditionTypes, setReconditionTypes] = useState([]);
  const [reconditionType, setReconditionType] = useState({
    text: "",
    value: "",
  });

  const [isTriangulation, setIsTriangulation] = useState(false);
  const [salePriceType, setSalePriceType] = useState("FullPrice");
  const [deliveryNote, setDeliveryNote] = useState("");
  const [notes, setNotes] = useState("");
  const [isDamaged, setIsDamaged] = useState(false);

  const idCompany = useSelector((state) => state.common.company);
  const customerCode = useSelector((state) => state.actas.customerCode);
  const shopCode = useSelector((state) => state.actas.shopCode);
  const jdaLocationCode = useSelector((state) => state.actas.jdaLocationCode);

  const [columns, setColumns] = useState([]);
  const [tableHeigth, setTableHeigth] = useState(340);
  const [selectedInvoiceHeads, setSelectedInvoiceHeads] = useState([]);
  const [existingDossiers, setExistingDossiers] = useState([]);

  var navigate = useNavigate();
  const { setLoading } = useLoading();

  const [invoice, setInvoice] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const page = useRef(0);
  const maxPage = useRef(0);
  const rowsForPage = 10;
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [checkCustomerEnabled, setCheckCustomerEnabled] = useState(false);

  useEffect(() => {
    if (
      customerCode === null ||
      customerCode === undefined ||
      customerCode === ""
    ) {
      toast.error(intl.formatMessage({ id: "RACreation.NoActAs" }));
      navigate(`${process.env.PUBLIC_URL}/ActAs`);
      return;
    } else {
      setCheckCustomerEnabled(true);
    }
  }, []);

  useEffect(() => {
    if (type.value != "") {
      getWarehouseDestinations();
    }
  }, [type, salePriceType, isDamaged, isTriangulation]);

  useEffect(() => {
    if (
      warehouseDestination?.value != "" &&
      warehouseDestination?.value != undefined &&
      warehouseDestination != null
    ) {
      getReconditionTypes();
    }
  }, [warehouseDestination]);

  useEffect(() => {
    handleChangeWarehouseDestination();
    //setReconditionType({ text: "", value: "", idRFType: ""});
    handleChangeReconditionType();
  }, [type, salePriceType, isDamaged]);

  useEffect(() => {
    getColumns();
  }, []);

  useEffect(() => {
    if (checkCustomerEnabled) {
      checkIfCustomerIsEnabled();
    }
  }, [checkCustomerEnabled]);

  const handleChangeDossierType = (item) => {
    setIsTriangulation(item.value == "T");
    setType(item);
  };

  const handleSalePriceTypeChange = (event) => {
    setSalePriceType(event.target.value);
  };

  const getReconditionTypes = async () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    params.append("idJDALocationDestination", warehouseDestination.value);
    params.append("rfTypeGroup", type.text);
    axios
      .get("/creditnotereturnfiles/reconditiontypes", { params })
      .then((response) => {
        setLoading(false);
        var selectReconditionTypes = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectReconditionTypes.push({
              value: x.idReconditionType,
              text: x.description,
            });
          });
        }
        setReconditionTypes(selectReconditionTypes);

        if (selectReconditionTypes.length == 1) {
          setReconditionType({
            text: response.data[0].description,
            value: response.data[0].idReconditionType,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getWarehouseDestinations = async () => {
    setLoading(true);

    axios
      .get("/creditnotereturnfiles/warehousedestinations", {
        params: {
          salePriceType: salePriceType,
          isDamaged: isDamaged,
          isTriangulation: isTriangulation,
          customerCode: customerCode,
          jdaLocation: jdaLocationCode,
        },
      })
      .then((response) => {
        setLoading(false);
        var selectWhdestinations = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectWhdestinations.push({
              value: x.idJDALocationDestination,
              text: x.jdaLocation + " - " + x.description,
            });
          });
        }
        setWarehouseDestinations(selectWhdestinations);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleActCreateDossier = async () => {
    if(existingDossiers.length == 0 || selectedInvoiceHeads.length == 0){
      toast.error(intl.formatMessage({ id: "Error.SelectInvoice" }))
      return;
    }
    var lgiDossiers = [...existingDossiers];
    var selectedInvoices = [...selectedInvoiceHeads];
    var dossiersToCreate = [];

    selectedInvoices.forEach((invoice) => {
      var lgiDossier = lgiDossiers.find(
        (d) => d.idStealthInvoiceHead === invoice
      );
      if (lgiDossier != undefined && lgiDossier != null) {
        dossiersToCreate.push({
          IdStealthInvoiceHead: lgiDossier.idStealthInvoiceHead,
          LGIRADossier: lgiDossier.raDossier,
        });
      }
    });

    if(type.text == '' || warehouseDestination.value == '' ||  reconditionType.value == ''){
      toast.error(intl.formatMessage({ id: "Error.FillRequiredFields" }))
      return;
    }

    let model = {
      IdCompany: idCompany,
      DossierType: type.text,
      Discriminant: salePriceType,
      IsDamaged: isDamaged,
      IdJDALocationDestination: warehouseDestination.value,
      IdReconditionType: reconditionType.value,
      Note: notes,
      DeliveryNotes: deliveryNote,
      SenderCustomerCode: customerCode,
      SenderShopCode: shopCode,
      Invoices: dossiersToCreate,
    };
    setLoading(true);
    axios
      .post("/stealthinvoices/create", model)
      .then((response) => {
        setLoading(false);
        toast.success("Saved!");
        if(response.data) {
          navigate(`${process.env.PUBLIC_URL}/RAPreparing/${response.data[0]}`);
        } else {
          navigate(`${process.env.PUBLIC_URL}/RASearch`);
        }
          
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleCheckBoxChange = (event) => {
    setIsDamaged(event.target.checked);
  };

  const handleChangeReconditionType = (item) => {
    if (item != null) {
      setReconditionType(item);
    } else {
      setReconditionType({ text: "", value: "" });
    }
  };

  const handleChangeWarehouseDestination = (item) => {
    if (item != null) {
      setWarehouseDestination(item);
    } else {
      setWarehouseDestination({ text: "", value: "" });
    }

    setReconditionType({ text: "", value: "" });
    setReconditionTypes([]);
  };

  const getColumns = () => {
    setColumns([
      {
        field: "invoiceNumber",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "FromInvoice.Invoice" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 400,
      },
      {
        field: "raDossier",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "FromInvoice.RADossier" })}
          />
        ),
        flex: 1,
        renderCell: (params) => {
          let inputRowId = "input-raDossier-" + params.row.idStealthInvoiceHead;
          return (
            <Input
              id={inputRowId}
              type="text"
              sx={{ width: "100%" }}
              value={params.row.raDossier}
              onChange={(e) =>
                handleRADossierChange(e, params.row.idStealthInvoiceHead)
              }
            ></Input>
          );
        },
      },
    ]);
  };

  const onSelectionFunc = (ids) => {
    var selected = [];
    ids.forEach((id) => {
      var row = rows.find((row) => row.idStealthInvoiceHead === id);
      selected.push(row.idStealthInvoiceHead);
    });
    setSelectedInvoiceHeads(selected);
  };

  const handleSearch = () => {
    setLoading(true);
    const params = new URLSearchParams([]);

    if (fromDate !== undefined && fromDate !== "" && fromDate !== null) {
      var date = fromDate.toISOString().substring(0, 10);
      params.append("StartDate", date);
    }

    if (toDate !== undefined && toDate !== "" && toDate !== null) {
      var date = toDate.toISOString().substring(0, 10);
      params.append("EndDate", date);
    }

    if (page.current === 0) {
      page.current = 1;
    }
    params.append("PagingInfo.Skip", `${rowsForPage * (page.current - 1)}`);
    params.append("PagingInfo.Take", rowsForPage);
    params.append("Invoice", invoice);
    axios
      .get("/stealthinvoices", { params })
      .then((response) => {
        setLoading(false);

        var data = [];
        response.data.paginatedItems.map((x) => {
          var item = x;
          data.push(item);
        });

        setRows(data);
        setTotalCount(response.data.totalCount);
        maxPage.current = Math.ceil(response.data.totalCount / rowsForPage);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, () => {
          errorToast(error, intl);
        });
      });
  };

  const handleRADossierChange = (e, idStealthInvoiceHead) => {
    var dossiers = existingDossiers;
    const index = dossiers.findIndex(
      (dossier) => dossier.idStealthInvoiceHead === idStealthInvoiceHead
    );
    if (index > -1) {
      dossiers.splice(index, 1);
    }
    dossiers.push({
      idStealthInvoiceHead: idStealthInvoiceHead,
      raDossier: e.target.value,
    });
    setExistingDossiers(dossiers);
  };

  const handleNextPage = () => {
    if (page.current < maxPage.current) {
      page.current = page.current + 1;
      handleSearch();
    }
  };

  const handlePreviousPage = () => {
    if (page.current > 1) {
      page.current = page.current - 1;
      handleSearch();
    }
  };

  const checkIfCustomerIsEnabled = async () => {
    setLoading(true);
    axios
      .get(`/stealthinvoices/${customerCode}/customerenabled`)
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
        navigate(`${process.env.PUBLIC_URL}/ActAs`);
      });
  };

  return (
    <div>
      <PageHeader title={intl.formatMessage({ id: "FromInvoice.Title" })} />
      <Grid container spacing={5}>
        <Grid item xs={12} lg={6} mt={3}>
          <CustomInput
            labelText={intl.formatMessage({ id: "RA.Type" })}
            type="autocomplete"
            value={type}
            selectItems={types}
            setValue={handleChangeDossierType}
            textCol={3}
            inputCol={9}
          />
          <Grid container mt={1} mb={1}>
            <Grid item xs={12} lg={6}>
              <FormControl>
                <RadioGroup
                  row
                  disabled
                  defaultValue={salePriceType}
                  value={salePriceType}
                  onChange={handleSalePriceTypeChange}
                  sx={{
                    border: 2,
                    borderColor: "#85ABD5",
                    borderRadius: "15px",
                    paddingRight: "15px",
                  }}
                >
                  <FormControlLabel
                    value="FullPrice"
                    control={<Radio />}
                    label={
                      <Typography>
                        {intl.formatMessage({ id: "General.FullPrice" })}
                      </Typography>
                    }
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="MarkDown"
                    control={<Radio />}
                    label={
                      <Typography>
                        {intl.formatMessage({ id: "General.MarkDown" })}
                      </Typography>
                    }
                    labelPlacement="start"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {!isTriangulation ? (
              <Grid item xs={12} lg={6}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isDamaged}
                        onChange={handleCheckBoxChange}
                      />
                    }
                    label={intl.formatMessage({ id: "General.Damaged" })}
                  />
                </FormGroup>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
          <CustomInput
            labelText={
              isTriangulation
                ? intl.formatMessage({
                    id: "ManualRTV.TriangulatiomWarehouse",
                  })
                : intl.formatMessage({ id: "ManualRTV.TrecateWarehouse" })
            }
            type="autocomplete"
            value={warehouseDestination}
            selectItems={warehouseDestinations}
            setValue={handleChangeWarehouseDestination}
            textCol={3}
            inputCol={9}
          />
          {!isTriangulation ? (
            <CustomInput
              labelText={intl.formatMessage({ id: "RA.ReconditionType" })}
              type="autocomplete"
              value={reconditionType}
              selectItems={reconditionTypes}
              //setValue={setReconditionType}
              setValue={handleChangeReconditionType}
              textCol={3}
              inputCol={9}
            />
          ) : (
            ""
          )}
        </Grid>
        <Grid item xs={12} lg={6} mt={3}>
          <CustomInput
            labelText={intl.formatMessage({ id: "ManualRTV.DeliveryNotes" })}
            type="textMultiline"
            value={deliveryNote}
            setValue={setDeliveryNote}
            textCol={2}
            inputCol={10}
          />
          <CustomInput
            labelText={intl.formatMessage({ id: "RADetails.Notes" })}
            type="textMultiline"
            value={notes}
            setValue={setNotes}
            textCol={2}
            inputCol={10}
          />
        </Grid>
      </Grid>
      <Grid container spacing={5} pt={0.5}>
        <Grid item xs={6} lg={6}>
          <CustomInput
            labelText={intl.formatMessage({ id: "FromInvoice.Invoice" })}
            type="text"
            value={invoice}
            setValue={setInvoice}
            textCol={3}
            inputCol={9}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <CustomInput
            labelText={intl.formatMessage({ id: "RASearch.FromDate" })}
            type="date"
            valueRef={fromDate}
            setValue={setFromDate}
            textCol={4}
            inputCol={8}
          />
        </Grid>
        <Grid item xs={6} lg={3}>
          <CustomInput
            labelText={intl.formatMessage({ id: "RASearch.ToDate" })}
            type="date"
            valueRef={toDate}
            setValue={setToDate}
            textCol={4}
            inputCol={8}
          />
        </Grid>
      </Grid>
      <Grid container mt={1} mb={1}>
        <Grid item lg={12}>
          <Button
            variant="contained"
            className="apeLigthBlueBackground"
            sx={{ mt: 1, mr: 1 }}
            onClick={handleSearch}
          >
            {intl.formatMessage({ id: "General.Search" })}
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} lg={12}>
          <CustomTablePagingInfo
            totalCount={totalCount}
            page={page.current}
            maxPage={maxPage.current}
            handlePreviousPage={handlePreviousPage}
            handleNextPage={handleNextPage}
          />
          <CustomTable
            columns={columns}
            rows={rows}
            id={"idStealthInvoiceHead"}
            rowHeight={50}
            headerHeight={40}
            tableHeight={tableHeigth}
            enableSelection={true}
            setSelectedRows={onSelectionFunc}
          />
        </Grid>
        <Grid item lg={12}>
          <Button
            variant="contained"
            className="apeLigthBlueBackground"
            sx={{ mt: 1, mr: 1 }}
            onClick={handleActCreateDossier}
          >
            {intl.formatMessage({ id: "ManualRTV.CreateDossier" })}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default FromInvoice;
